// extracted by mini-css-extract-plugin
export default {"back":"SurveyStepFooter_back__y-bsP","navigation":"SurveyStepFooter_navigation__+yNvP","next":"SurveyStepFooter_next__XyYPe"};